<template>
  <div id="reviews-detail">
    <div class="ipub-h2 relative mar-b-10">
      Reviews and Comments for Manuscript No. <font @click="linkto"
            class="ipub-c-p link-color">{{personInfo.code}}</font>
    </div>
    <div>
      <div class="ipub-h3 line-h-40 mar-b-10 ipub-title-tab">
        {{decisionStatus[responseData.decisionStatus]}} (Report {{responseData.sign}})
      </div>
      <div class="mar-b-20 ipub-p2 ipub-title-tab-part">
        <div class="flex mar-b-10">
          <div style="width:140px"
               class="fw-bd">Reviewer</div>
          <div style="width:calc(100% - 140px)"
               class="mar-l-30">{{personInfo.person && title[personInfo.person.titleCode]}}{{personInfo.person && personInfo.person.firstName}} {{personInfo.person && personInfo.person.lastName}} (Reviewer {{responseData.seq}})</div>
        </div>
        <div class="flex mar-b-10">
          <div style="width:140px"
               class="fw-bd">Email</div>
          <div style="width:calc(100% - 140px)"
               class="mar-l-30">{{personInfo.person && personInfo.person.email}}</div>
        </div>
        <div class="flex mar-b-10">
          <div class="fw-bd"
               style="width:140px">Affiliation</div>
          <div style="width:calc(100% - 140px)"
               class="mar-l-30">{{personInfo.person && personInfo.person.affiliation}}</div>
        </div>
        <div class="flex mar-b-10"
             v-if="personInfo.person && personInfo.person.countryCode">
          <div class="fw-bd"
               style="width:140px">Country</div>
          <div style="width:calc(100% - 140px)"
               class="mar-l-30">
            <template v-if="personInfo.person && personInfo.person.countryCode">{{personInfo.person && country[personInfo.person.countryCode]}}</template>
            <template v-else>--</template>
          </div>
        </div>
        <div class="flex mar-b-10"
             v-if="personInfo.person && personInfo.person.keyword">
          <div class="fw-bd"
               style="width:140px">Research Keywords</div>
          <div style="width:calc(100% - 140px)"
               class="mar-l-30">
            {{personInfo.person.keyword}}
          </div>
        </div>
      </div>
    </div>
    <div class="ipub-p2 flex mar-b-10 reviewTab ipub-cursor-pointer">
      <div v-for="(value,key) in personInfo.decisionHistoryList"
           @click="checkVersion(value)"
           :class="['version-list',activeKey==value.sign?'active':'']"
           :key="value.id">
        <strong style="font-size:16px"
                v-if="value.seq"
                class="success-color">
          <ipub-icon type="iconAble" />
        </strong>
        Report {{value.sign}} - V{{value.sign}} <font class="key-color"
              v-if="!value.seq && value.sign===personInfo.currentSign">（Pending accepted）</font>
        <div>
          <div class="ipub-p2 fw-bd">{{decisionStatus[value.decisionStatus]}}</div>
          <span class="ipub-p2">{{$moment(value.completedTime).format('DD MMMM YYYY')}}</span>
        </div>
      </div>
    </div>
    <div class="content-bg mar-b-40"
         style="padding: 20px 18px;">
      <div class="mar-b-10">
        <div class="ipub-p2 fw-bd mar-b-20">
          <span>Review the Revised Manuscript</span><span class="mar-l-40">{{responseData.revised?'Yes':'No'}}</span>
        </div>
        <div class="ipub-p2 fw-bd mar-b-20">
          <span>Review Rating</span><span class="mar-l-40">{{responseData.rating?rate[responseData.rating]:'--'}}</span>
          <template v-if="user.codeList&&user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS.EDIT_REVIEW_RATING')">
            <ipub-icon type="iconEdit"
                       @click="rating"
                       class="mar-l-10 link-color ipub-c-p"></ipub-icon>
          </template>

        </div>
        <div class="mar-b-10">
          <div class="ipub-p2 fw-bd line-h-40 mar-b-10 ipub-title-tab ipub-cursor-pointer"
               @click="e => {showVersion = !showVersion}">
            Custom Review Questions
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate',!showVersion?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div v-if="showVersion">
            <customerReviewQuestion :questionList="responseData.questionList"></customerReviewQuestion>
          </div>
        </div>

        <div>
          <div class="ipub-p2 fw-bd line-h-40 mar-b-10 ipub-title-tab ipub-cursor-pointer"
               @click="e => {showEditor = !showEditor}">
            Comments to Editor
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate',!showEditor?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div class="mar-b-10"
               v-if="showEditor">
            <div class="ipub-p2"
                 v-if="responseData.editorNotes"
                 v-html="responseData.editorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
            <template v-else>
              <div class="line-color">No notes or comments.</div>
            </template>

          </div>
        </div>

        <div>
          <div class="ipub-p2 fw-bd line-h-40 mar-b-10 ipub-title-tab ipub-cursor-pointer"
               @click="e => {showAuthor = !showAuthor}">
            Comments to Author
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate ',!showAuthor?'':'rotate-180']"
                       @click="e => {showAuthor = !showAuthor}"
                       type="iconArrow" />
          </div>
          <div class="mar-b-20"
               v-if="showAuthor">
            <div class="ipub-p2"
                 v-if="responseData.authorNotes"
                 v-html="responseData.authorNotes.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
            <template v-else>
              <div class="line-color">No notes or comments.</div>
            </template>
          </div>
        </div>

        <div v-if="responseData.reviewerFileList && responseData.reviewerFileList.length>0">
          <div class="ipub-p2 fw-bd line-h-40 mar-b-20 ipub-title-tab ipub-cursor-pointer"
               @click="e => {showFile = !showFile}">Attachment(s)
            <ipub-icon :class="['ipub-p5 mar-l-40 rotate ',!showFile?'':'rotate-180']"
                       type="iconArrow" />
          </div>
          <div class="file-contain mar-b-10"
               v-if="showFile">
            <ipub-label class="mar-b-10 ipub-p2"
                        type="link"
                        style="margin-right:10px"
                        hover
                        @click="download(item)"
                        :key="index"
                        v-for="(item,index) in responseData.reviewerFileList">
              <span class="ipub-p2 color tag">{{item.name}} </span>
              <ipub-icon type="iconDownload1"
                         class="mar-l-10"></ipub-icon>
            </ipub-label>
          </div>
          <ipub-radio class="ipub-p2"
                      :checked="responseData.reviewFileVisible"
                      @change="e=>{fileToAcademic(e,'reviewFileVisible')}">
            Visible to Academic Editor
          </ipub-radio>
        </div>
      </div>
      <!-- 作者回复 -->
      <div class="mar-b-40"
           v-if="responseData.authorReply || (responseData.authorReplyFileList && responseData.authorReplyFileList.length>0)">
        <div class="ipub-p2 fw-bd line-h-40 mar-b-10 ipub-title-tab ipub-cursor-pointer"
             @click="e => {showResponse = !showResponse}">
          Author’s Response to Report {{responseData.sign}}
          <ipub-icon :class="['ipub-p5 mar-l-40 rotate',!showResponse?'':'rotate-180']"
                     type="iconArrow" />
        </div>
        <div v-if="showResponse">
          <div>
            <div class="ipub-p2 fw-bd relative mar-b-10"
                 style="cursor:pointer"
                 v-if="responseData.sign===personInfo.currentSign-1 || (responseData.sign!=personInfo.currentSign-1 && responseData.authorReply)">
              Author’s Response
            </div>
            <div class="ipub-p2 mar-b-30 font-color"
                 v-if="!isEdit"
                 v-html="responseData.authorReply?responseData.authorReply.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' '):'- -'">
              <!-- {{responseData.authorReply}} -->
            </div>
            <ipub-textarea class="mar-b-20"
                           placeholder="Author’s Note"
                           v-model="editData.authorReply"
                           v-if="isEdit"
                           :autoSize="{ cols: '', rows: '10' }" />
          </div>
          <div class="mar-b-20">
            <div class="ipub-p2 fw-bd mar-b-10 flex"
                 style="margin-right:12px"
                 v-if="responseData.sign===personInfo.currentSign-1 || (responseData.sign!=personInfo.currentSign-1 && responseData.authorReplyFileList && responseData.authorReplyFileList.length)">Author’s Response File
              <ipub-radio class="ipub-p2 mar-l-20"
                          v-if="!isEdit"
                          :checked="responseData.authorFileVisible"
                          @change="(e)=>{fileToAcademic(e,'authorFileVisible')}">
                Visible to Academic Editor
              </ipub-radio>
              <div class="mar-l-10"
                   v-if="isEdit">
                <ipub-upload @change="handleUpload"
                             multiple
                             v-if="!loading"
                             class="link-color ipub-c-p">
                  <ipub-icon type="iconAdd" /> Add New Document
                </ipub-upload>
                <font class="line-color"
                      v-else>
                  <ipub-icon :type="loading?'loading':'iconAdd'" /> Add New Document
                </font>
              </div>
            </div>
            <div class="file-contain">
              <ipub-label class="mar-b-10 flex"
                          style="margin-right:10px"
                          :key="item.id"
                          v-for="(item,index) in authorFile">
                <span class="ipub-p2"
                      style="cursor:pointer"
                      @click="download(item,index)">
                  <ipub-radio :checked="item.authorShowed"
                              @change="reviewAuthor(item)"
                              v-show="isEdit"
                              checkBox
                              label="" />{{item.name}}
                  <ipub-icon type="iconDownload1"
                             class="mar-l-10 border-right"></ipub-icon>
                  <ipub-icon class="ipub-p5 mar-l-10 ipub-cursor-pointer"
                             @click="del(index)"
                             v-show="isEdit"
                             type="iconDelete" />
                </span>
              </ipub-label>
            </div>
          </div>
          <div v-if="!isEdit && responseData.seq && responseData.sign===personInfo.currentSign-1">
            <ipub-button type="primary"
                         size="small"
                         @click="editResponse">
              Edit Author's Notes
            </ipub-button>
          </div>
          <div v-if="isEdit">
            <ipub-button type="primary"
                         plain
                         size="small"
                         :style="{ minWidth: '150px' }"
                         @click="cancel">Cancel</ipub-button>
            <ipub-button type="primary"
                         size="small"
                         :style="{ minWidth: '150px' }"
                         @click="save">Save</ipub-button>
          </div>
        </div>
      </div>
    </div>
    <div class="mar-b-40">
      <template v-if="user.codeList && user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS.ACCEPT_REPORT')">
        <ipub-button v-if="!responseData.seq && responseData.sign===personInfo.currentSign"
                     type="primary"
                     :style="{ minWidth: '150px' }"
                     @click="report()">Accept Report</ipub-button>
      </template>
      <template v-if="user.codeList && user.codeList.includes('EDITOR_TASK.MANUSCRIPTS.MANUSCRIPT_DETAILS.VIEW_REPORTS.CANCEL_REVIEW_REPORT')">
        <ipub-button type="primary"
                     v-if="responseData.seq && responseData.sign===personInfo.currentSign && ['PENDING_REVIEW','PENDING_PRE_CHECK','PRE_CHECK_DONE','UNDER_REVIEW','REVISED_REVIEW','PENDING_FIRST_DECISION','FIRST_DECISION_DONE','PENDING_FINAL_DECISION','FINAL_DECISION_DONE'].includes(personInfo.status)"
                     :style="{ minWidth: '150px' }"
                     @click="cancelReport()">Cancel Review Report</ipub-button>
      </template>

    </div>

    <review-rating :isVisable="ratingVisable"
                   :inputData="inputData"
                   @confirm="cancelRating"
                   @cancel="cancelRating"></review-rating>
  </div>
</template>



<script>
import main from './main'
export default main

</script>

<style lang="scss" scoped>
@import './main.scss';
#reviews-detail {
  .reviewTab {
    height: 92px;
    .version-list {
      width: 50%;
      padding: 10px 18px 0;
    }
    .active {
      background: $content_color;
      border-bottom: 3px solid $link_color;
    }
  }
}
</style>
